package com.nonopn.skydome.common.app.pages.main.model.api

import kotlinx.serialization.Serializable

@Serializable
data class SectionProjectAndThunderDetection(
    val project: Project,
    val less2Km: Int,
    val less1Km: Int,
    val topActivity: List<Top>
) {
    @Serializable
    data class Top(
        val percent: Double,
        val activity: ThunderDetectionActivity,
    )
}
